var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpaceDashSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 12.5C0.966667 12.5 0.652778 12.3694 0.391667 12.1083C0.130556 11.8472 0 11.5333 0 11.1667V1.83333C0 1.46667 0.130556 1.15278 0.391667 0.891667C0.652778 0.630556 0.966667 0.5 1.33333 0.5H10.6667C11.0333 0.5 11.3472 0.630556 11.6083 0.891667C11.8694 1.15278 12 1.46667 12 1.83333V11.1667C12 11.5333 11.8694 11.8472 11.6083 12.1083C11.3472 12.3694 11.0333 12.5 10.6667 12.5H1.33333ZM1.33333 11.1667H5.33333V1.83333H1.33333V11.1667ZM6.66667 11.1667H10.6667V6.5H6.66667V11.1667ZM6.66667 5.16667H10.6667V1.83333H6.66667V5.16667Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceDashSvg);
export default __webpack_public_path__ + "static/media/SpaceDashSVG.36ed6bac1117348ecae7092d979437b9.svg";
export { ForwardRef as ReactComponent };